// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Y-o1Q","center":"Footer_center__8zf0O"};